import Keycloak from '../vendor/keycloak-js/keycloak.mjs';
import log from 'loglevel';

/**
 * Die default min. Validitätsschwelle für den Access Token in Sekunden.
 */
const DEFAULT_TOKEN_MIN_VALIDITY = 20;

const KEYCLOAK_INIT_OPTIONS = {
    onLoad: 'check-sso',
    checkLoginIframe: false,
    redirectUri: window.url
};

const KEYCLOAK = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL || '',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || ''
});

KEYCLOAK.onTokenExpired = async () => {
    try {
        await refreshAccessToken();
    } catch (e) {
        log.warn('Failed to refresh token, forcing user to re-authenticate.', e);
        KEYCLOAK.login({prompt: 'login'});
    }
};

/**
 * Prüft ob der Benutzer authentifiziert ist.
 */
export async function checkAuthentication() {
    // Authentifizierung kann für lokale Entwicklung/Cypress/Test deaktiviert werden.
    if (process.env.REACT_APP_DEV_DISABLE_AUTHENTICATION === 'true') {
        return log.warn('Authentication is disabled!');
    }

    try {
        const authenticated = await KEYCLOAK.init(KEYCLOAK_INIT_OPTIONS);
        log.debug(`User is ${authenticated ? 'authenticated' : 'not authenticated'}`);
    } catch (error) {
        log.error('Failed to initialize adapter:', error);
    }
}

/**
 * Meldet den Benutzer ab.
 */
export function logout() {
    return KEYCLOAK.logout();
}

/**
 * Lädt die die Account-Daten des aktuell angemeldeten Benutzers.
 */
export function loadUserProfile() {
    return KEYCLOAK.loadUserProfile();
}

/**
 * Erzeugt eine URL zum Keycloak-Login.
 */
export function createLoginUrl(options) {
    return KEYCLOAK.createLoginUrl(options);
}

/**
 * Erzeugt eine URL zu dem Keycloak-Account des aktuell angemeldeten Benutzers.
 */
export function createAccountUrl() {
    return KEYCLOAK.createAccountUrl();
}

/**
 * Prüft ob der Benutzer aktuell authentifiziert ist.
 */
export function isAuthenticated() {
    return KEYCLOAK.authenticated;
}

/**
 * Liefert den Token des aktuell angemeldeten Benutzers.
 */
export function getAccessToken() {
    return KEYCLOAK.token;
}

/**
 * Liefert den Token des aktuell angemeldeten Benutzers in geparster Form.
 */
export function getAccessTokenParsed() {
    return KEYCLOAK.tokenParsed;
}

/**
 * Führt einen refresh des Access Token durch, falls notwendig.
 *
 * @param minValidity Die Zeitschwelle bei deren unterschreiten der aktuelle Access Token refreshed wird.
 *  Ist er noch länger als diese Zeit gültig wird der Token nicht refreshed.
 */
export async function refreshAccessToken(minValidity = DEFAULT_TOKEN_MIN_VALIDITY) {
    return KEYCLOAK.updateToken(minValidity);
}
